import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import type { ErrorHandlerProps } from '@trello/error-boundaries';
import { forTemplate } from '@trello/legacy-i18n';
import {
  useBoardShortLink,
  useCardShortLink,
  useRouteId,
} from '@trello/router';

import { RequestAccessPageSkeleton } from './RequestAccessPageSkeleton';

import styles from './RequestAccessErrorHandler.less';
const format = forTemplate('request_access');

export const RequestAccessErrorHandler: FunctionComponent<
  ErrorHandlerProps
> = ({ caughtError }) => {
  const { error, info } = caughtError;
  const boardShortLink = useBoardShortLink();
  const cardShortLink = useCardShortLink();
  const routeId = useRouteId();

  useEffect(() => {
    Analytics.sendOperationalEvent({
      action: 'errored',
      actionSubject: 'requestAccess',
      actionSubjectId: 'requestAccessError',
      source: 'requestAccessScreen',
      attributes: {
        error,
        info,
        flow: routeId,
        shortLink: boardShortLink || cardShortLink,
      },
    });
  }, [boardShortLink, cardShortLink, routeId, error, info]);

  return (
    <RequestAccessPageSkeleton>
      <h1 className={styles.textCenter}>
        {format('request-access-page-error-title')}
      </h1>
      <p className={styles.textCenter}>
        {format('request-access-page-error-description')}
      </p>
    </RequestAccessPageSkeleton>
  );
};
